'use client';

import React, { useState } from 'react';
import { CheckSquare, Square, ClipboardList } from 'lucide-react';

const checklistItems = [
  { id: 'chk-001', step: 1, text: 'Check available location (if phone/tracked item)', done: true },
  { id: 'chk-002', step: 2, text: 'Activate Lost Mode in RETURNI', done: true },
  { id: 'chk-003', step: 3, text: 'Offer a finder reward to increase return chance', done: true },
  { id: 'chk-004', step: 4, text: 'Contact the last place you had the item', done: false },
  { id: 'chk-005', step: 5, text: 'Share description with friends / family', done: false },
  { id: 'chk-006', step: 6, text: 'File a police report (especially for high-value items)', done: false },
  { id: 'chk-007', step: 7, text: 'Contact your insurer with serial number / receipt', done: false },
  { id: 'chk-008', step: 8, text: 'Monitor RETURNI for scan alerts', done: false },
];

export default function RecoveryChecklist() {
  const [items, setItems] = useState(checklistItems);

  const toggle = (id: string) => {
    setItems((prev) => prev.map((item) => item.id === id ? { ...item, done: !item.done } : item));
  };

  const doneCount = items.filter((i) => i.done).length;
  const progress = Math.round((doneCount / items.length) * 100);

  return (
    <div className="bg-white rounded-2xl border border-border shadow-card overflow-hidden">
      <div className="px-6 py-4 border-b border-border flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-blue-100 rounded-xl flex items-center justify-center">
            <ClipboardList size={15} className="text-blue-600" />
          </div>
          <div>
            <h2 className="font-700 text-base text-foreground">Recovery Checklist</h2>
            <p className="text-xs text-muted-foreground">{doneCount} of {items.length} steps completed</p>
          </div>
        </div>
        <span className="font-800 text-xl text-foreground tabular-nums">{progress}%</span>
      </div>

      {/* Progress bar */}
      <div className="h-1.5 bg-secondary">
        <div
          className="h-full bg-accent rounded-full transition-all duration-500"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="p-5 flex flex-col gap-2">
        {items.map(({ id, step, text, done }) => (
          <button
            key={id}
            onClick={() => toggle(id)}
            className={`flex items-start gap-3 p-3 rounded-xl text-left transition-all duration-150 ${
              done ? 'bg-accent/5 hover:bg-accent/8' : 'bg-white hover:bg-secondary'
            }`}
          >
            <div className="flex-shrink-0 mt-0.5">
              {done ? (
                <CheckSquare size={17} className="text-accent" />
              ) : (
                <Square size={17} className="text-muted-foreground" />
              )}
            </div>
            <div className="flex items-start gap-2 flex-1">
              <span className={`text-[10px] font-700 tabular-nums mt-0.5 flex-shrink-0 ${done ? 'text-accent' : 'text-muted-foreground'}`}>
                {step < 10 ? `0${step}` : step}
              </span>
              <span className={`text-sm leading-relaxed ${done ? 'line-through text-muted-foreground' : 'text-foreground font-500'}`}>
                {text}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}